import d from './DOM.js';

export default class InstallMT5 {
	public static init() {
		const urlCode = d.get<HTMLElement>('webrequest-url');
		
		if (urlCode) {
			urlCode.addEventListener('click', () => {
				const text = urlCode.innerText;
				
				navigator.clipboard.writeText(text).then(() => {
					const originalText = urlCode.innerText;
					urlCode.innerText = 'Copied!';
					urlCode.style.color = '#2ecc71'; // Green color
					
					setTimeout(() => {
						urlCode.innerText = originalText;
						urlCode.style.color = ''; // Reset color
					}, 2000);
				}).catch(err => {
					console.error('Failed to copy text: ', err);
				});
			});
		}
	}
}
